import { tokens } from "../../theme";
import * as React from "react";
import * as CONSTANT from "../../constants/Constant";


import {
  Box,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import SectionHeader from "../../components/SectionHeader";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { DataGrid } from "@mui/x-data-grid";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import {
  getFromLocalStorage,
  saveToLocalStorageJsonObject,
  getFromLocalStorageJsonObject,
} from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { isAuthPageAtom, showErrorAlertDialog } from "../../config/AppConfig";
import {
  ALERT,
  ERROR,
  ERROR_WHILE_FETCHING_DATA,
  FETCHING_PAYOUT_DETAILS_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  PROCESSING_PLEASE_WAIT,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
  SOME_ERROR_OCCURRED,
  LOADING_REPORT_NAMES_PLEASE_WAIT,
} from "../../constants/Strings";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import DebugLog from "../../utils/DebugLog";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_ROLE,
  USER_NAME,
  SELECTED_PAYOUT_CYCLE,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import {
  payoutRequestApproval,
  getPayoutTotalHeaderSummary,
  getPayoutDealerHeaderSummary,
  getPayoutSummaryTransactionType,
  payoutApproval,
  holdPayoutTransactionType,
  } from "../../services/ApiService";
import HighlightsSecondary from "../../components/HighlightsSecondary";
import HighlightsPrimary from "../../components/HighlightsPrimary";
import NoDataFound from "../../components/NoDataFound";
import { payoutDetailsColumnHeader } from "../../components/ColumnHeader";
import CustomButton from "../../components/CustomButton";
import { formatPrice } from "../../utils/PriceFormatter";

import { getButtonVisibilityData } from "../../utils/GetButtonVisibilityAsPerLoginResponse";
import { IncentivesActionsConfirmationDialog } from "../../components/IncentivesActionsConfirmationDialog";
import { DownloadPayoutOnHoldReportNameSelectionDialog } from "../../components/DownloadPayoutOnHoldReportNameSelectionDialog";
import useAxiosHook from "../../hooks/UseAxios";

// Filter Configurations to be passed to SearchBarFilter in SectionHeader
const filterProps = [
  {
    keyValue: "Transaction Type",
    displayName: "Name",
    paramName: "transactionType",
    isDateFilter: false,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },

  // {
  //     keyValue: 'Payout Status',
  //     displayName: 'Status',
  //     paramName: 'payoutStatus',
  //     isDateFilter: false,
  //     isSearchBarDropdown: true,
  //     searchBarDropdownOptions: [
  //         "Pending Review",
  //         "Pending Approval",
  //         "Completed",
  //         "Hold",
  //         "Cancel",
  //         "Release Approval"
  //     ],
  // },
  {
    keyValue: "Cutoff Date",
    displayName: "Cutoff",
    paramName: "cutoffDate",
    isDateFilter: true,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
  {
    keyValue: "Payout Date",
    displayName: "Payout By",
    paramName: "payoutDate",
    isDateFilter: true,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
];

const ReceiptIconSvg = () => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.6094 26.6332C10.7027 25.4599 12.3694 25.5532 13.3294 26.8332L14.6761 28.6332C15.7561 30.0599 17.5027 30.0599 18.5827 28.6332L19.9294 26.8332C20.8894 25.5532 22.5561 25.4599 23.6494 26.6332C26.0227 29.1665 27.9561 28.3265 27.9561 24.7799V9.7532C27.9694 4.37987 26.7161 3.0332 21.6761 3.0332H11.5961C6.55607 3.0332 5.30273 4.37987 5.30273 9.7532V24.7665C5.30273 28.3265 7.2494 29.1532 9.6094 26.6332Z"
      stroke="#292D32"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3027 9.70117H21.9694"
      stroke="#292D32"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6367 15.0332H20.6367"
      stroke="#292D32"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PayoutsArchive = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNetworkConnectionAvailable = UseOnlineStatus();

  const navigate = useNavigate();
  const location = useLocation();
  let selectedPayoutCycle = location.state;

  const [, setAuthStatus] = useAtom(isAuthPageAtom);
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");

  const [payoutCycleName, setPayoutCycleName] = useState("");
  const [payoutHeaderSummary, setPayoutHeaderSummary] = useState([]); // Sample Data == {"totalAmount":621.3,"dealerCount":62,"transactionCount":327,"netPayoutAmount":621.3,"holdDealerCount":0,"holdTransactionCount":0,"holdAmount":0}}
  const [payoutDealerHeaderSummary, setPayoutDealerHeaderSummary] = useState(
    []
  );
  const [payoutSummary, setPayoutSummary] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid

  // pagination
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });
  const [pageSize, setPageSize] = useState(15);
  const [totalNoOfRows, setTotalNoOfRows] = useState(0);
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);

  const [selectedRows, setSelectedRows] = React.useState([]);
  const [userRole, setUserRole] = useState([]);

  // button visibility
  const [onHoldButtonVisible, setOnHoldButtonVisibility] = useState(false);
  const [downloadButtonVisible, setDownloadButton] = useState(false);
  const [requestApprovalButtonVisibility, setRequestApprovalButton] =
    useState(false);
  const [approvelButtonVisibility, setApproveButton] = useState(false);
  const [commentButtonVisibility, setComment] = useState(false);

  // actions confirmation dialog
  const [dialogOpen, setDialogOpen] = useState(false);
  const [clickedButtonType, setClickedButtonType] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");
  const [downloadFileDialogOpen, setDownloadFileDialogOpen] = useState(false);
  const [batchNo, setBatchNo] = useState("");
  const { data, error, showProgressBar, fetchData } = useAxiosHook();
  const [reportNameOptions, setReportNameOptions] = useState([]);
  const [reportNamesValue, setReportNamesValue] = useState([]);
  const [downloadType, setDownloadType] = useState("");

  // filter and search
  const [selectedFilter, setSelectedFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  // sort model
  const [sortModel, setSortModel] = useState([]);

  // sorting handling 
  useEffect(() => {
    checkSelectedPayoutCycle();
    getPayoutTransactionType(
      selectedPayoutCycle?.batchNo,
      selectedPayoutCycle?.commissionType,
      paginationModel.page,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  }, [sortModel]);

  useEffect(() => {
    if (showProgressBar) {
      setProgressbarText(LOADING_REPORT_NAMES_PLEASE_WAIT);
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [showProgressBar]);

  useEffect(() => {
    if (error) {
      if (error.message !== null && error.message === "Network Error") {
        showErrorAlert(ERROR, error.message);
      } else if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
        alert(error.data.displayErrorMessage);
        navigate(CONSTANT.LOGIN);
      } else {
        const message =
          error.data !== null ? error.data.displayErrorMessage : error.message;
        showErrorAlert(
          ERROR,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      }
    }
  }, [error]);

  function getReportNamesFromApi(batchNo) {
    try {
      const requestObject = {
        batchNo: batchNo,
      };

      initializeEncryption(
        requestObject,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.GET_REPORT_NAMES_LIST
      ).then((encryptedContentData) => {
        fetchData(
          process.env.REACT_APP_REPORT_NAMES_API_URL,
          ApiType.GET_REPORT_NAMES_LIST,
          ApiType.POST_METHOD,
          encryptedContentData,
          {},
          (data) => {
            if (data !== null) {
              if (data.result.reportNames.length > 0) {
                setReportNameOptions(
                  data.result.reportNames.map((item) => item.reportName)
                );
                setReportNamesValue(data.result.reportNames);
              } else {
                showErrorAlert(ALERT, CONSTANT.ERROR_IN_LOADING_REPORT_NAMES);
              }
            }
          }
        );
      });
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  const getReportName = (type) => {
    setDownloadType(type);
    getReportNamesFromApi(batchNo);
  };

  useEffect(() => {
    if (reportNameOptions.length > 0) {
      openDownloadOptionsDialog(downloadType);
    }
  }, [reportNameOptions]);

  const openDownloadOptionsDialog = (type) => {
    if (isNetworkConnectionAvailable) {
      let title = "";
      if (type === "Download") {
        title = "Download";
      }
      setClickedButtonType(type);
      setDialogTitle(title);
      setDownloadFileDialogOpen(true);
    } else {
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
    }
  };

  useEffect(() => {
    getUserRole();
    checkSelectedPayoutCycle();
    updateButtonVisibility();

    setPayoutCycleName(selectedPayoutCycle?.payoutCycleName);
    setBatchNo(selectedPayoutCycle?.batchNo);
    if (selectedPayoutCycle?.batchNo && selectedPayoutCycle?.commissionType) {
      requestApi(
        selectedPayoutCycle?.batchNo,
        selectedPayoutCycle?.commissionType
      );
    } else {
      showErrorAlert(ERROR, "Invalid payout cycle data");
    }
  }, []);

  useEffect(() => {
    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, rowsPerPage]);

  async function requestApi(batchNo, commissionType) {
    try {
      getTotalHeaderSummary(batchNo);
      getDealerHeaderSummary(batchNo);

      getPayoutTransactionType(
        batchNo,
        commissionType,
        0,
        paginationModel.pageSize,
        selectedFilter,
        searchQuery
      );
    } catch (error) {
      handleError(error);
    }
  }

  function getUserRole() {
    setUserRole(getFromLocalStorage(USER_ROLE));
  }

  function checkSelectedPayoutCycle() {
    // If selectedPayoutCycle is not in the location state (e.g., after a page refresh),
    // try to retrieve it from localStorage
    if (!selectedPayoutCycle) {
      const storedData = getFromLocalStorageJsonObject(
        SELECTED_PAYOUT_CYCLE,
        JSON.stringify(selectedPayoutCycle)
      );
      selectedPayoutCycle = storedData ? JSON.parse(storedData) : null;
    } else {
      // If payoutRowSelected is in the location state, store it in localStorage
      saveToLocalStorageJsonObject(
        SELECTED_PAYOUT_CYCLE,
        JSON.stringify(selectedPayoutCycle)
      );
    }
  }

  const updateButtonVisibility = () => {
    const actionButtonList = getButtonVisibilityData("Incentive", "Payout");
    if (actionButtonList) {
      actionButtonList.forEach((items, index) => {
        // HOLD, DOWNLOAD, APPROVE, VIEW, REQUEST APPROVAL
        if (items.buttonName === "DOWNLOAD") {
          setDownloadButton(true);
        } else if (
          items.buttonName === "REQUEST APPROVAL" &&
          selectedPayoutCycle?.showRequestApproval
        ) {
          setRequestApprovalButton(true);
        } else if (
          items.buttonName === "APPROVE" &&
          selectedPayoutCycle?.showApproval
        ) {
          setApproveButton(true);
        } else if (
          items.buttonName === "HOLD" &&
          selectedPayoutCycle?.showHold
        ) {
          setOnHoldButtonVisibility(true);
        }
      });
    }
  };

  /******* Confirmation Dialog Methods ***********/
  const handleDialogOpen = (type) => {
    // check selected data
    const selectedData = payoutSummary.filter((row) =>
      selectedRows.includes(row.id)
    );
    if (selectedData.length <= 0) {
      showErrorAlert("Alert", "Please choose some rows first!");
    } else {
      let title = "";
      if (type === "Hold") {
        title = "Hold";
      } else if (type === "Approve") {
        title = "Approve";
      } else if (type === "Request Approval") {
        title = "Request Approval";
      }
      setClickedButtonType(type);
      setDialogTitle(title);
      setDialogOpen(true);
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleSubmit = (file, comment, type, selectedDate) => {
    dialogResponseRecieved(file, comment, type, selectedDate);
  };

  const dialogResponseRecieved = (file, comment, type, selectedDate) => {
    // get the batch no and version code which is the same for all data in the same page
    checkSelectedPayoutCycle();
    const extractBatchNo = selectedPayoutCycle?.batchNo;
    const extractVersionCode = selectedPayoutCycle?.version;

    // check selected data
    const selectedData = payoutSummary.filter((row) =>
      selectedRows.includes(row.id)
    );

    DebugLog("file: " + file);

    // check if there is attachment and set accordingly
    let fileNameWithoutExtension = null;
    if (file) {
      fileNameWithoutExtension = file.name.split(".").slice(0, -1).join(".");
    }

    let contentData = {};

    switch (type) {
      case "Hold":
        let transactionTypesArray = [];
        selectedData.forEach((element) => {
          transactionTypesArray.push(element.transactionType);
        });
        if (file) {
          readFileAsBase64(file)
            .then((base64String) => {
              contentData = {
                batchNo: extractBatchNo,
                version: extractVersionCode,
                remark: comment,
                transactionTypes: transactionTypesArray,
                fileName: fileNameWithoutExtension,
                fileType: file.type,
              };

              requestPayoutTransTypeOnHold(contentData, base64String);
            })
            .catch((error) => {
              console.error("Error reading file:", error);
            });
        } else {
        

          contentData = {
            batchNo: extractBatchNo,
            version: extractVersionCode,
            remark: comment,
            transactionTypes: transactionTypesArray,
          };

          requestPayoutTransTypeOnHold(contentData);
        }
        break;

      case "Request Approval":
        if (file) {
          readFileAsBase64(file)
            .then((base64String) => {
              contentData = {
                batchNo: extractBatchNo,
                version: extractVersionCode,
                remark: comment,
                fileName: fileNameWithoutExtension,
                fileType: file.type,
              };

              payoutRequestApprovalApi(contentData, base64String);
            })
            .catch((error) => {
              console.error("Error reading file:", error);
            });
        } else {
          contentData = {
            batchNo: extractBatchNo,
            version: extractVersionCode,
            remark: comment,
          };

          payoutRequestApprovalApi(contentData);
        }

        break;

      case "Approve":
        if (file) {
          readFileAsBase64(file)
            .then((base64String) => {
              contentData = {
                batchNo: extractBatchNo,
                version: extractVersionCode,
                remark: comment,
                selectedDate: selectedDate,
                fileName: fileNameWithoutExtension,
                fileType: file.type,
              };

              callApprovePayoutAPI(contentData, base64String);
            })
            .catch((error) => {
              console.error("Error reading file:", error);
            });
        } else {
          contentData = {
            batchNo: extractBatchNo,
            version: extractVersionCode,
            remark: comment,
            selectedDate: selectedDate,
          };

          callApprovePayoutAPI(contentData);
        }
        break;

      default:
        showErrorAlert("Error", "Invalid action type!");
    }
  };

  function readFileAsBase64(file) {
    return new Promise((resolve, reject) => {
      if (!file) {
        reject("No file provided");
      }

      const reader = new FileReader();
      reader.onload = function (event) {
        // event.target.result contains the base64 string
        // We need to extract the base64 part from the Data URL
        const base64String = event.target.result.split(",")[1];
        resolve(base64String);
      };
      reader.onerror = reject;

      reader.readAsDataURL(file);
    });
  }

  /********  Pagination Methods ***********/
  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });
    checkSelectedPayoutCycle();

    getPayoutTransactionType(
      selectedPayoutCycle?.batchNo,
      selectedPayoutCycle?.commissionType,
      newPage,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  };

  const handlePageChange = (newPage) => {
    setPaginationModel({ pageSize: pageSize, page: newPage });
    checkSelectedPayoutCycle();

    getPayoutTransactionType(
      selectedPayoutCycle?.batchNo,
      selectedPayoutCycle?.commissionType,
      newPage,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  };

  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });
    checkSelectedPayoutCycle();

    // call api with new page size and start from page 0.
    getPayoutTransactionType(
      selectedPayoutCycle?.batchNo,
      selectedPayoutCycle?.commissionType,
      0,
      newPageSize,
      selectedFilter,
      searchQuery
    );
  };

  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
  };

  const resetSelection = () => {
    setSelectedRows([]);
  };

  /****** API Calls ******/
  async function getTotalHeaderSummary(receivedBatchNo) {
    try {
      if (!isNetworkConnectionAvailable) {
        throw new Error(NO_INTERNET_CONNECTION_FOUND);
      }

      const contentData = {
        batchNo: receivedBatchNo,
      };

      const encryptedContentData = await initializeEncryption(
        contentData,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.PAYOUT_TOTAL_HEADER_SUMMARY
      );

      const payoutSummaryRequestData = {
        requestId: generateRequestId(),
        loginId: getFromLocalStorage(LOGIN_ID),
        sessionId: getFromLocalStorage(SESSION_ID),
        loginUserName: getFromLocalStorage(USER_NAME),
        contentData: encryptedContentData,
      };

      getPayoutTotalHeaderSummary(payoutSummaryRequestData)
        .then((response) => {
          setPayoutHeaderSummary(response.data.result);
        })
        .catch((error) => {
          handleError(error);
        });
    } catch (error) {
      handleError(error);
    }
  }

  async function getDealerHeaderSummary(receivedBatchNo) {
    try {
      if (!isNetworkConnectionAvailable) {
        throw new Error(NO_INTERNET_CONNECTION_FOUND);
      }

      const contentData = {
        batchNo: receivedBatchNo,
      };

      const encryptedContentData = await initializeEncryption(
        contentData,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.PAYOUT_DEALER_HEADER_SUMMARY
      );

      const payoutSummaryRequestData = {
        requestId: generateRequestId(),
        loginId: getFromLocalStorage(LOGIN_ID),
        sessionId: getFromLocalStorage(SESSION_ID),
        loginUserName: getFromLocalStorage(USER_NAME),
        contentData: encryptedContentData,
      };

      getPayoutDealerHeaderSummary(payoutSummaryRequestData)
        .then((response) => {
          setPayoutDealerHeaderSummary(response.data.result);
        })
        .catch((error) => {
          handleError(error);
        });
    } catch (error) {
      handleError(error);
    }
  }

  async function getPayoutTransactionType(
    receivedBatchNo,
    commissionType,
    pageNo,
    pageSize,
    selectedFilter,
    searchQuery
  ) {
    try {
      if (!isNetworkConnectionAvailable) {
        throw new Error(NO_INTERNET_CONNECTION_FOUND);
      }
      setProgressbarText(FETCHING_PAYOUT_DETAILS_PLEASE_WAIT);
      setLoading(true); // Hide the progress dialog

      const contentData = createRequestObject(
        receivedBatchNo,
        commissionType,
        pageNo,
        pageSize,
        selectedFilter,
        searchQuery
      );

      const encryptedContentData = await initializeEncryption(
        contentData,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.GET_PAYOUT_SUMMARY_TRANSACTION_TYPE
      );

      const payoutSummaryRequestData = {
        requestId: generateRequestId(),
        loginId: getFromLocalStorage(LOGIN_ID),
        sessionId: getFromLocalStorage(SESSION_ID),
        loginUserName: getFromLocalStorage(USER_NAME),
        contentData: encryptedContentData,
      };

      getPayoutSummaryTransactionType(payoutSummaryRequestData)
        .then((response) => {
          const responseData = response.data.result.content.map((row) => ({
            ...row,
            id: generateRandomId(),
          }));
          setPayoutSummary(responseData);
          setRowsPerPage(response.data.result.content.length);
          setTotalNoOfRows(response.data.result.totalElements);
          setTotalNoOfPages(response.data.result.totalPages);

          setLoading(false);
        })
        .catch((error) => {
          handleError(error);
        });
    } catch (error) {
      handleError(error);
    }
  }

  // Create Request Object for getPayoutTransactionType API
  function createRequestObject(
    receivedBatchNo,
    commissionType,
    pageNumber,
    pageSize,
    selectedFilter,
    filterValue
  ) {
    // Initialize all fields to null
    let requestObject = {
      batchNo: receivedBatchNo,
      commissionType: commissionType,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };

    // Set the appropriate field based on filterCriteria
    if (
      selectedFilter != null &&
      selectedFilter != undefined &&
      selectedFilter != "" &&
      selectedFilter.paramName != ""
    ) {
      if (
        filterValue != null &&
        filterValue != undefined &&
        filterValue != ""
      ) {
        requestObject[selectedFilter] = filterValue;
      }
    }

    // sorting
    try{
      if (sortModel.length > 0) {
        // set sortProperty according to the field
        switch (sortModel[0].field) {
          case "transactionType":
            requestObject.sortProperty = "TRANSACTION_TYPE";
            break;
          case "reportDate":
            requestObject.sortProperty = "REPORT_DATE";
            break;
          case "cutoffDate":
            requestObject.sortProperty = "CUT_OFF";
            break;
          case "payoutDate":
            requestObject.sortProperty = "PAYOUT_BY";
            break;
          default:
            break;
        }
        // set the sort order
        requestObject.sortOrder = sortModel[0].sort.toString().toUpperCase();
      } 
    } catch (error) {
      DebugLog("Error in sorting: " + error);
      requestObject.sortProperty = null;
      requestObject.sortOrder = null;
    }
      return requestObject;
  }

  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  async function requestPayoutTransTypeOnHold(contentData,fileContentBase64String) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(PROCESSING_PLEASE_WAIT);
        setLoading(true); // Hide the progress dialog

        const encryptedContentData = await initializeEncryption(
          contentData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.HOLD_PAYOUT_TRANSACTION_TYPE
        );

        const requestData = {
          requestId: generateRequestId(),
          loginId: getFromLocalStorage(LOGIN_ID),
          sessionId: getFromLocalStorage(SESSION_ID),
          contentData: encryptedContentData,
          fileContent: fileContentBase64String,
        };

        holdPayoutTransactionType(requestData)
          .then((response) => {
            if (response.data.responseCode === "0") {
              navigate("/PayoutsActionItemsSuccess", {
                state: { data: response.data.result, type: 1 },
              });
            }
            resetSelection();
            setLoading(false);
          })
          .catch((error) => {
            handleError(error);
          });
      }
    } catch (error) {
      handleError(error);
    }
  }

  async function payoutRequestApprovalApi(
    requestData,
    fileContentBase64String
  ) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(PROCESSING_PLEASE_WAIT);
        setLoading(true); // Hide the progress dialog

        initializeEncryption(
          requestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.REQUEST_APPROVAL_PAYOUT
        ).then((encryptedContentData) => {
          const payoutRequestApprovalData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
            fileContent: fileContentBase64String,
          };

          payoutRequestApproval(payoutRequestApprovalData)
            .then((response) => {
              setLoading(false);
              resetSelection();

              if (response.data.responseCode === "0") {
                navigate("/PayoutsActionItemsSuccess", {
                  state: { data: response.data.result, type: 2 },
                });
              }
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  async function callApprovePayoutAPI(contentData, fileContentBase64String) {
    try {
      if (!isNetworkConnectionAvailable) {
        throw new Error(NO_INTERNET_CONNECTION_FOUND);
      }

      setProgressbarText(PROCESSING_PLEASE_WAIT);
      setLoading(true);

      const encryptedContentData = await initializeEncryption(
        contentData,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.APPROVE_PAYOUT
      );

      console.log("encryptedContentData: ", encryptedContentData);

      const requestData = {
        requestId: generateRequestId(),
        loginId: getFromLocalStorage(LOGIN_ID),
        sessionId: getFromLocalStorage(SESSION_ID),
        loginUserName: getFromLocalStorage(USER_NAME),
        contentData: encryptedContentData,
        fileContent: fileContentBase64String,
      };

      console.log("requestData: ", requestData);

      payoutApproval(requestData)
        .then((response) => {
          setLoading(false);
          console.log("response: ", response);

          if (response.data.responseCode === "0") {
            navigate("/PayoutsActionItemsSuccess", {
              state: { data: response.data.result, type: 0 },
            });
          }
        })
        .catch((error) => {
          handleError(error);
        });
    } catch (error) {
      handleError(error);
    }
  }

  const handleSearch = (filterParam, searchQuery) => {
    setSelectedFilter(filterParam);
    setSearchQuery(searchQuery);

    setPaginationModel({ pageSize: pageSize, page: 0 });
    checkSelectedPayoutCycle();

    getPayoutTransactionType(
      selectedPayoutCycle?.batchNo,
      selectedPayoutCycle?.commissionType,
      0,
      paginationModel.pageSize,
      filterParam,
      searchQuery
    );
  };

  // handle error code reusable block
  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    }

    const errorCode = error.data?.errorCode;
    var errorMessage =
      error.data != null ? error.data.displayErrorMessage : SOME_ERROR_OCCURRED;

    if (error.data?.displayErrorMessage) {
      errorMessage = error.data.displayErrorMessage;
    }

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),
      // [ApiErrorCode.UNABLE_TO_PROCESS_ERROR]: () =>
      //   navigate(CONSTANT.FINANCE_DASHBOARD),
      default: () =>
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(errorMessage)
        ),
    };

    (errorActions[errorCode] || errorActions.default)();
  }

  function showErrorAlert(title, content) {
    try {
      DebugLog("error.data=====" + content);
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  /***** Navigation *******/
  const handleBackClicked = () => {
    checkSelectedPayoutCycle();
    if (selectedPayoutCycle.flowFrom === CONSTANT.PAYOUT_ROUTE) {
      navigate(CONSTANT.PAYOUT_ROUTE);
    } else {
      navigate(CONSTANT.FINANCE_DASHBOARD);
    }
  };

  const handleFileDownloadSubmit = (fileType, type, startDate, endDate) => {
    // downloadWithholdingReport(fileType, startDate, endDate);
  };

  const handleFileDownloadDialogClose = () => {
    setDownloadFileDialogOpen(false);
  };

  const handleRowClick = (params) => {
    checkSelectedPayoutCycle();

    // navigate to next layer for dealerBreakdown
    navigate(CONSTANT.PAYOUT_DEALER_BREAKDOWN, {
      state: {
        batchNo: params.row.batchNo,
        version: params.row.version,
        commissionType: params.row.commissionType,
        transactionType: params.row.transactionType,

        showApproval: selectedPayoutCycle?.showApproval,
        showCancel: selectedPayoutCycle?.showCancel,
        showHold: selectedPayoutCycle?.showHold,
        showRelease: selectedPayoutCycle?.showRelease,
        showRequestApproval: selectedPayoutCycle?.showRequestApproval,
        showRequestRelease: selectedPayoutCycle?.showRequestRelease,
      },
    });
  };
  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />

        <DownloadPayoutOnHoldReportNameSelectionDialog
          open={downloadFileDialogOpen}
          handleClose={handleFileDownloadDialogClose}
          handleSubmit={handleFileDownloadSubmit}
          batchNo={batchNo}
          type={clickedButtonType}
          title={dialogTitle}
          reportNameOption={reportNameOptions}
          reportNamesList={reportNamesValue}
        />
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}

        {/* Header */}
        <Grid container direction={"row"} alignItems={"center"} mb={2} ml={2}>
          <Grid item mr={2}>
            <IconButton onClick={handleBackClicked} width={12}>
              <img src={"../../assets/common/Back.svg"} width={12} />
            </IconButton>
          </Grid>
          <Grid item>
            <Typography
              color={colors.grey[100]}
              fontWeight={"600"}
              variant="h3"
            >
              {payoutCycleName}
            </Typography>
          </Grid>
        </Grid>
        {/* Header */}

        {/* Highlights Section */}

        <HighlightsPrimary
          highlightTotal={"RM " + formatPrice(payoutHeaderSummary.totalAmount)}
          highlightPayOut={
            "RM " + formatPrice(payoutHeaderSummary.netPayoutAmount)
          }
          payoutDealers={payoutHeaderSummary.dealerCount}
          payoutTransactions={payoutHeaderSummary.transactionCount}
          onHold={"RM " + formatPrice(payoutHeaderSummary.holdAmount)}
          onHoldDealers={payoutHeaderSummary.holdDealerCount}
          onHoldTransactions={payoutHeaderSummary.holdTransactionCount}
        ></HighlightsPrimary>

        <HighlightsSecondary
          highlightTotal={
            "RM " + formatPrice(payoutDealerHeaderSummary.dealerTotal)
          }
          highlightTotal2={
            "RM " + formatPrice(payoutDealerHeaderSummary.masterDealerTotal)
          }
          prepaidAmount={
            "RM " + formatPrice(payoutDealerHeaderSummary.dealerPrepaidAmount)
          }
          prepaidAmount2={
            "RM " +
            formatPrice(payoutDealerHeaderSummary.masterDealerPrepaidAmount)
          }
          postpaidAmount={
            "RM " + formatPrice(payoutDealerHeaderSummary.dealerPostpaidAmount)
          }
          postpaidAmount2={
            "RM " +
            formatPrice(payoutDealerHeaderSummary.masterDealerPostpaidAmount)
          }
        ></HighlightsSecondary>

        {/* Highlights Section */}

        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Validations Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={2}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            pb={0}
          >
            <SectionHeader
              sectionIcon={ReceiptIconSvg}
              sectionHeading={"Transaction Type(s)"}
              isSearchBarEnabled={true}
              filterProps={filterProps}
              onSearch={handleSearch}
            ></SectionHeader>

            {/* <SimpleTable
          statusData={"In Validation"}
          statusBG={colors.primary[300]}
          data={payoutSummary}
        ></SimpleTable> */}

            {payoutSummary.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[600],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[300]} !important`,
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // opacity:.5
                  },
                }}
              >
                <DataGrid
                  classes={{ row: "dataGridRow" }}
                  rows={payoutSummary}
                  columns={payoutDetailsColumnHeader}
                  checkboxSelection
                  selectionModel={selectedRows}
                  onSelectionModelChange={handleSelectionChange}
                  disableSelectionOnClick // Disable row selection on row click
                  pageSize={pageSize}
                  rowCount={totalNoOfRows}
                  paginationModel={paginationModel}
                  paginationMode="server"
                  keepNonExistentRowsSelected
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                  rowsPerPageOptions={[15, 30, 45, 60]}
                  // useResizeContainer
                  //           columnBuffer={2} // Adjusts the number of columns rendered outside the viewport
                  // autoPageSize // Automatically adjusts the page size based on the available height
                  autoHeight // Adjusts the height of the grid to fit its content
                  onRowClick={handleRowClick}

                  sortModel={sortModel}
                  onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                />
              </Box>
            ) : (
              NoDataFound()
            )}
          </Grid>

          {payoutSummary.length > 0 ? (
            <Box item mt={2} ml={1}>
              <Typography>
                <span>Jump to page: </span>
                <select
                  value={paginationModel.page + 1}
                  onChange={handlePageJump}
                >
                  {[...Array(totalNoOfPages)].map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </Typography>
            </Box>
          ) : (
            ""
          )}

          {/* Validations Section */}
        </Grid>

        {/* Confirmation Dialog */}
        <IncentivesActionsConfirmationDialog
          open={dialogOpen}
          handleClose={handleDialogClose}
          handleSubmit={handleSubmit}
          type={clickedButtonType}
          title={dialogTitle}
        />
        {/* Confirmation Dialog */}

        {/* Action Buttons */}

        {payoutSummary.length > 0 ? (
          <Grid item mt={1} justifyContent={"flex-start"} pb={20} mr={10}>
            <Stack direction="row" spacing={2} justifyContent={"flex-end"}>
              {commentButtonVisibility ? (
                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  // btnStartIcon={
                  //   <img src="../../assets/common/Cross.svg" width={22} />
                  // }
                  btnTxt={"Comment"}
                ></CustomButton>
              ) : (
                ""
              )}

              {onHoldButtonVisible ? (
                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  btnStartIcon={
                    <img
                      src="../../assets/common/on_hold_button_icon.png"
                      width={22}
                    />
                  }
                  btnTxt={"Hold"}
                  // onClick={putPayoutOnHold}
                  onClick={() => handleDialogOpen("Hold")}
                ></CustomButton>
              ) : (
                ""
              )}

              {/* {downloadButtonVisible ? (
                <DownloadDropdownButton
                  onFileTypeSelected={downloadOnHoldDetails}
                />
              ) : (
                ""
              )} */}
              {downloadButtonVisible ? (
                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  btnStartIcon={
                    <img src="../../assets/common/Download.svg" width={22} />
                  }
                  btnTxt={"Download"}
                  onClick={() => getReportName("Download")}
                ></CustomButton>
              ) : (
                ""
              )}

              {requestApprovalButtonVisibility ? (
                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  btnStartIcon={
                    <img
                      src="../../assets/common/approve_button_icon.png"
                      width={22}
                    />
                  }
                  btnTxt={"Request Approval"}
                  // onClick={requestPayoutApproval}
                  onClick={() => handleDialogOpen("Request Approval")}
                ></CustomButton>
              ) : (
                ""
              )}

              {approvelButtonVisibility ? (
                <CustomButton
                  btnBG={colors.redAccent[200]}
                  btnColor={colors.grey[900]}
                  btnStartIcon={
                    <img
                      src="../../assets/common/approve_icon.svg"
                      width={22}
                    />
                  }
                  btnTxt={"Approve"}
                  // onClick={requestPayoutApproval}
                  onClick={() => handleDialogOpen("Approve")}
                ></CustomButton>
              ) : (
                ""
              )}
            </Stack>
          </Grid>
        ) : (
          ""
        )}

        {/* Action Buttons */}
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
};

export default PayoutsArchive;
